import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SpreadsheetGuide from "@/pages/article/guide/page";
import ArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/basetao-review",
    element: <ArticlePage />,
  },
  {
    path: "/is-basetao-legit",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-experience",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-shipping-cost",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-shipping-guide",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-warehouse",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-qc-process",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-coupon",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-discount-code",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-pros-cons",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;